import React from 'react'
import styled from 'styled-components'
import { IBook } from '../../types'
import { Flex, Text } from '@radix-ui/themes'
import { LockClosedIcon } from '@radix-ui/react-icons'
import { useNavigate } from 'react-router-dom'

export const BookItem: React.FC<{ book: IBook, width: number }> = ({ book, width }) => {

  const navigate = useNavigate()

  function onBookClick() {
    navigate(`books/${book.uuid}/`)
  }

  return (
    <Wrapper width={`${width}px`} mr="4" direction="column" onClick={onBookClick}>
      <Flex px="2" py="2" flexGrow="1" align="center">
        <Text weight="medium" align="center" size="1">{book.imprint_raw}</Text>
      </Flex>
      <Info px="2" py="2" align="center" justify="between">
        <Text align="center" size="1">{book.page_count} стр.</Text>
        {
          !book.can_view_unblured_book && <LockClosedIcon/>
        }
      </Info>
    </Wrapper>
  )
}


const Wrapper = styled(Flex)`
  cursor: pointer;
  border: 1px solid var(--gray-6);
  background-color: var(--gray-1);
  height: 100%;
  overflow: hidden !important;

  &:hover {
    background-color: var(--accent-4);
  }
`

const Info = styled(Flex)`
  background-color: rgba(0, 0, 0, 0.1);
`
